var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.08,
    height: 28.869,
    viewBox: "0 0 23.08 28.869",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.879,
    y1: 0.847,
    x2: 0.179,
    y2: 0.291,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#40eefe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b402f6"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_13",
    "data-name": "Union 13",
    d: "M19292.01,28.869a5.006,5.006,0,0,1-4.992-5.394l1.246-15.736a2.424,2.424,0,0,1,2.408-2.224h2.016a5.862,5.862,0,0,1,11.7,0h2.018a2.427,2.427,0,0,1,2.408,2.229l1.25,15.726a5.006,5.006,0,0,1-5,5.4Zm-2.447-5.2a2.462,2.462,0,0,0,2.447,2.641h13.061a2.457,2.457,0,0,0,2.447-2.646l-1.236-15.6h-1.881V9.625a1.276,1.276,0,1,1-2.553,0V8.069h-6.615V9.625a1.277,1.277,0,1,1-2.555,0V8.069h-1.881Zm5.689-18.159h6.576a3.306,3.306,0,0,0-6.576,0Zm1.26,14.543-1.982-1.987a1.281,1.281,0,0,1,0-1.808,1.275,1.275,0,0,1,1.8,0l1.08,1.086,3.334-3.334a1.278,1.278,0,0,1,1.8,0,1.28,1.28,0,0,1,0,1.808l-4.232,4.236a1.28,1.28,0,0,1-1.807,0Z",
    transform: "translate(-19287.002)",
    fill: "url(#linear-gradient)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.1305f50e71f6ceffa9def01d7a1f6921.svg";
export { ForwardRef as ReactComponent };